export default function Quote({ className }) {
  const classes = ["h-6 fill-current w-7 text-good-green-100"].concat(className)
  return (
    <svg
      viewBox="0 0 28.6 23.2"
      className={classes.join(" ")}
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-405.000000, -1363.000000)">
        <g transform="translate(402.000000, 1352.000000)">
          <g>
            <path
              d="M15.1,14.4c-1.9,1.5-3.4,3-4.4,4.5s-1.6,2.9-1.6,4.3C9.3,23.1,9.6,23,9.9,23c0.3,0,0.7,0,0.9,0c1.2,0,2.3,0.5,3.1,1.5
          c0.8,1,1.2,2.2,1.2,3.6c0,1.8-0.6,3.2-1.8,4.4c-1.2,1.2-2.6,1.8-4.4,1.8c-1.9,0-3.3-0.7-4.4-2C3.5,30.8,3,29,3,26.7
          c0-2.7,0.8-5.4,2.5-8.1c1.7-2.7,4.1-5.2,7.3-7.6L15.1,14.4z M31.6,14.4c-1.9,1.5-3.4,3-4.4,4.5c-1,1.5-1.6,2.9-1.6,4.3
          c0.2-0.1,0.5-0.2,0.8-0.2c0.3,0,0.7,0,0.9,0c1.2,0,2.3,0.5,3.1,1.5c0.8,1,1.2,2.2,1.2,3.6c0,1.8-0.6,3.2-1.8,4.4
          c-1.2,1.2-2.6,1.8-4.4,1.8c-1.9,0-3.3-0.7-4.4-2c-1.1-1.4-1.6-3.2-1.6-5.5c0-2.7,0.8-5.4,2.5-8.1c1.7-2.7,4.1-5.2,7.3-7.6
          L31.6,14.4z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
